/**
 * Global store status flags.
 *
 * SOLD_OUT: when true, all products display as sold out and add-to-cart /
 * buy-now actions are disabled across the site (Pre-Reserve + Notify Me
 * are shown instead).
 *
 * PREORDER: the launch pre-booking campaign. Customers pay in full now and
 * orders dispatch on the date below. While it is active, Cash on Delivery
 * is not offered — every pre-book is a prepaid order.
 */
export const SOLD_OUT = false;

/** Pre-booking campaign master switch. */
export const PREORDER_ACTIVE = false;

/** Dispatch date, ISO (used for feeds/structured data). */
export const PREORDER_DISPATCH_ISO = "2026-09-20";

/** Dispatch date as shown to customers. */
export const PREORDER_DISPATCH_LABEL = "20 September";

/** Short line used near prices and buy buttons. */
export const PREORDER_NOTE = `Pre-book now · pay in full · dispatches ${PREORDER_DISPATCH_LABEL}`;

/** Compact variant for tight spaces (cards, sticky bars). */
export const PREORDER_NOTE_SHORT = `Dispatches ${PREORDER_DISPATCH_LABEL}`;

/**
 * Cash on Delivery is open alongside the pre-book campaign.
 * Set back to `PREORDER_ACTIVE` to make pre-books prepaid only again.
 */
export const PREPAID_ONLY = false;

/**
 * SKUs that are announced but not yet purchasable. They show a
 * "Coming soon" state with Pre-Reserve / Notify me instead of buy actions.
 */
export const COMING_SOON_HANDLES: readonly string[] = ["ova-balance"];

export function isComingSoon(handle: string | null | undefined): boolean {
  if (!handle) return false;
  return COMING_SOON_HANDLES.includes(handle);
}

